import { FunctionComponent, ReactElement } from "react";
import { ParseHtml } from "@pjs/security";
import { IRichTextViewProps } from "./interfaces/IRichTextViewProps";
import "../../styles/rich-text-font-styles.css";

export const RichTextView: FunctionComponent<IRichTextViewProps> = (props): ReactElement => {
    return <ParseHtml className={`${props.className !== undefined ? props.className : ""} rt-content-font-styles`} htmlString={props.content} dataHook={props.dataHook} />;
};
